import { Pressable, StyleSheet } from 'react-native';
import RNTooltip, {
  type TooltipProps as RNTooltipProps,
} from 'react-native-walkthrough-tooltip';
import { Typography } from '@banhala/ui-kit';
import { useToggle } from '../hooks/useToggle';
import { isAndroid } from '../utils';

export interface ITooltip {
  open: () => void;
  close: () => void;
}

type TooltipProps = {
  /**
   * - 툴팁에 보여질 내용
   */
  label: string;
  /**
   * - 툴팁을 표시할 요소
   * - Pressable안에 그려지게 됩니다.
   */
  children: React.ReactNode;
  contentStyle?: RNTooltipProps['contentStyle'];
  tooltipStyle?: RNTooltipProps['tooltipStyle'];
};
export const Tooltip = ({
  label,
  children,
  contentStyle,
  tooltipStyle,
}: TooltipProps) => {
  const [show, toggle] = useToggle(false);
  return (
    <Pressable onPress={toggle}>
      <RNTooltip
        disableShadow
        showChildInTooltip={false}
        isVisible={show}
        backgroundColor="transparent"
        contentStyle={[styles.removeDefaultContentStyle, contentStyle]}
        arrowSize={{ width: 8, height: 7 }}
        tooltipStyle={[styles.tooltipStyle, tooltipStyle]}
        content={
          <Pressable style={styles.contentWrapper} onPress={toggle}>
            <Typography color={'content_always_white'}>{label}</Typography>
          </Pressable>
        }
        placement={'bottom'}
        onClose={toggle}
      >
        {children}
      </RNTooltip>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  removeDefaultContentStyle: {
    display: 'flex',
    marginLeft: 10,
    padding: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
  },
  contentWrapper: {
    borderRadius: 4,
    paddingVertical: 6,
    paddingHorizontal: 8,
    overflow: 'hidden',
  },
  tooltipStyle: {
    marginTop: isAndroid ? -30 : 0,
  },
});
